export const getLocalizedStepTitle = (i18n, title, stepIndex) =>
  i18n.getString(
    _TL_('Step {{number}}: {{title}}'),
    { number: stepIndex, title }
  );
